/**
 * // useWindowDimension.ts
 * * This hook returns the viewport/window height and width
 */

import { useEffect, useState } from 'react'

import { WINDOW_DIMENSION_MOBILE, WINDOW_DIMENSION_MOBILE_LG, WINDOW_DIMENSION_TABLET } from '@apps-common/config/window-dimensions'

type WindowDimensions = {
  width: number | undefined
  height: number | undefined
  size: 'xl' | 'lg' | 'md' | 'sm' | 'xs' | 'xxs' | null
  isTablet: boolean
  isMobileLg: boolean
  isMobile: boolean
}

export const useWindowDimensions = (): WindowDimensions => {
  const [windowDimensions, setWindowDimensions] = useState<WindowDimensions>({
    width: undefined,
    height: undefined,
    size: null,
    isTablet: false,
    isMobileLg: false,
    isMobile: false
  })

  const getSize = (width: number) => {
    if (width >= 1600) return 'xl'
    if (width >= 1200) return 'lg'
    if (width >= 996) return 'md'
    if (width >= 768) return 'sm'
    if (width >= 640) return 'xs'

    return 'xxs'
  }

  const getIsTablet = (width: number) => width > WINDOW_DIMENSION_MOBILE && width <= WINDOW_DIMENSION_TABLET
  const getIsMobileLg = (width: number) => width <= WINDOW_DIMENSION_MOBILE_LG
  const getIsMobile = (width: number) => width <= WINDOW_DIMENSION_MOBILE

  useEffect(() => {
    function handleResize(): void {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
        size: getSize(window.innerWidth),
        isTablet: getIsTablet(window.innerWidth),
        isMobileLg: getIsMobileLg(window.innerWidth),
        isMobile: getIsMobile(window.innerWidth)
      })
    }
    handleResize()
    window.addEventListener('resize', handleResize)

    return (): void => window.removeEventListener('resize', handleResize)
  }, [])

  return windowDimensions
}
